module.exports = __webpack_public_path__ + "img/banner-1.a9c1a482.png";